// ノートリンク（`[ラベル](ノート名)`）の判定と URL の組み立て。
// DOM にも通信にも依存しない純粋関数だけを置く。

/** 前後の空白を除いたリンク先が、自分の別のノート名として扱えるかを返す。 */
export function isNoteLinkTarget(rawTarget: string): boolean {
  const target = String(rawTarget ?? '').trim();
  if (target === '') {
    return false;
  }
  // 改行を含むものは 1 行のリンクとして成立しない。
  if (/[\r\n]/.test(target)) {
    return false;
  }
  // https:, mailto:, javascript: などスキーム付きは、安全でないものも含めてノート名にしない。
  if (/^[a-z][a-z0-9+.-]*:/i.test(target)) {
    return false;
  }
  // サイト内の絶対・相対パス、ページ内リンク、クエリだけのリンクは従来のリンクとして扱う。
  if (/^(?:\/|#|\.\/|\.\.\/|\?)/.test(target)) {
    return false;
  }
  // メールアドレスは mailto: に補完するリンクとして扱う。
  if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(target)) {
    return false;
  }
  return true;
}

/** ノート名からノートを開く URL（相対）を作る。 */
export function noteLinkHref(name: string): string {
  return `./?note_name=${encodeURIComponent(String(name ?? '').trim())}`;
}

/** ノートリンクの href から note_name を取り出す。無ければ null。例外は投げない。 */
export function noteLinkNameFromHref(href: string): string | null {
  const value = String(href ?? '');
  try {
    const url = new URL(value, 'http://note-link.invalid/');
    const name = url.searchParams.get('note_name');
    return name === null ? null : name;
  } catch {
    const match = value.match(/[?&]note_name=([^&#]*)/);
    if (!match) {
      return null;
    }
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return null;
    }
  }
}
